import { FILTER_PERSISTENCE_STORAGE_KEY } from '@common/contexts/filter-persistence';
import { endActivitySession } from '@common/services/activity-session/activity-session';
import { enqueueOneSignalOperation } from '@common/utils/one-signal-operation-queue';
import Socket from '../../../common/services/socket';
import Storage from '../../../common/services/storage';
import Interval from '../../../common/services/interval';
import { setUser } from '../../../../client/sentry';

export const LOGOUT_USER = 'core/LOGOUT_USER';

export default () => async (dispatch) => {
  // The end request needs the access token, so it has to go out before cookies are cleared.
  // Don't let a hung request trap logout; an in-flight call already has the token.
  await Promise.race([
    endActivitySession(),
    new Promise((resolve) => {
      setTimeout(resolve, 3000);
    }),
  ]);

  // Reset all services/storage related to the user
  await Storage.clear();
  try {
    sessionStorage.removeItem(FILTER_PERSISTENCE_STORAGE_KEY);
  } catch (error) {
    console.warn('Logout: failed to clear filter persistence from sessionStorage', error);
  }
  Socket.disconnect();
  Interval.clearAll();

  setUser(null);

  if (typeof window !== 'undefined') {
    try {
      await Promise.race([
        enqueueOneSignalOperation(async () => {
          const mod = await import('react-onesignal');
          const OneSignal = mod.default;
          if (OneSignal?.User) await OneSignal.logout();
        }),
        new Promise((_, reject) => setTimeout(() => reject(new Error('OneSignal logout timed out')), 3000)
        )
      ]);
    } catch (error) {
      console.warn('Logout: OneSignal.logout failed or timed out', error);
    }
  }

  // Wait with dispatching the logout action untill the route has been redirected
  // This fixes some weird bug in the router
  setTimeout(() => dispatch({ type: LOGOUT_USER, sync: true }), 100);
};
